export const fetchFranchiseYearByYear = async (teamId = 111) => {
  try {
    const [hitRes, pitRes] = await Promise.all([
      fetch(`https://statsapi.mlb.com/api/v1/teams/${teamId}/stats?stats=yearByYear&group=hitting`),
      fetch(`https://statsapi.mlb.com/api/v1/teams/${teamId}/stats?stats=yearByYear&group=pitching`)
    ]);
    const hitData = hitRes.ok ? await hitRes.json() : null;
    const pitData = pitRes.ok ? await pitRes.json() : null;
    return {
      hitting: hitData?.stats?.[0]?.splits || [],
      pitching: pitData?.stats?.[0]?.splits || []
    };
  } catch (err) {
    console.error('Failed to fetch franchise year-by-year data:', err);
    return { hitting: [], pitching: [] };
  }
};

export const fetchHistoricalSeason = async (season, teamId = 111) => {
  try {
    const [batRes, pitRes, standRes] = await Promise.all([
      fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=homeRuns,battingAverage,runsBattedIn,stolenBases,onBasePlusSlugging&teamId=${teamId}&season=${season}&limit=5&statGroup=hitting`),
      fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=era,strikeouts,wins,saves,whip&teamId=${teamId}&season=${season}&limit=5&statGroup=pitching`),
      fetch(`https://statsapi.mlb.com/api/v1/standings?leagueId=103&season=${season}`)
    ]);
    return {
      leadersBatting: batRes.ok ? await batRes.json() : null,
      leadersPitching: pitRes.ok ? await pitRes.json() : null,
      standings: standRes.ok ? await standRes.json() : null
    };
  } catch (err) {
    console.error(`Failed to fetch historical data for ${season}:`, err);
    return { leadersBatting: null, leadersPitching: null, standings: null };
  }
};